import { Property } from "csstype";
import style from "./video-call-ui.module.css";
import cn from "classnames";

type TChildren = React.ReactNode;

export function AvoidControls({ children }: { children: TChildren }) {
  return <div className={style.avoidControls}>{children}</div>;
}

export function Box({
  children,
  padding = "1rem",
  background = "white",
  border = "none",
  expandHeight = false,
}: {
  padding?: Property.Padding;
  background?: Property.Background;
  border?: Property.Border;
  expandHeight?: boolean;
  children: TChildren;
}) {
  return (
    <div className={cn(style.box, expandHeight && style.expandHeight)} style={{ padding, background, border }}>
      {children}
    </div>
  );
}

export function Stack({
  children,
  ...rest
}: {
  justifyContent?: Property.JustifyContent;
  alignItems?: Property.AlignItems;
  gap?: Property.Gap;
  children: TChildren;
}) {
  return (
    <div className={style.stack} style={rest}>
      {children}
    </div>
  );
}

export function Row({
  children,
  ...rest
}: {
  justifyContent?: Property.JustifyContent;
  alignItems?: Property.AlignItems;
  gap?: Property.Gap;
  children: TChildren;
}) {
  return (
    <div className={style.row} style={rest}>
      {children}
    </div>
  );
}
